module.exports = __webpack_public_path__ + "static/media/elan-title.7f5380ef.jpg";